import { ToolOutlined } from '@ant-design/icons';
import { Button } from 'antd';

import { useStartCorrection } from 'hooks';

export const StartCorrection = ({ queueId }: { queueId: number }) => {
  const [handleGetCorrection, { loading }] = useStartCorrection();

  return (
    <Button
      size='small'
      type='primary'
      icon={<ToolOutlined />}
      loading={loading}
      onClick={() => handleGetCorrection({ callbackQueryParams: { queueId } })}
    >
      Start Correction
    </Button>
  );
};
